import React from 'react';
import { SavedScenario } from '../types';
import { getScenarios, deleteScenario } from '../services/storage';

interface Props {
  onLoad: (scenario: SavedScenario) => void;
}

const SavedScenarios: React.FC<Props> = ({ onLoad }) => {
  const [scenarios, setScenarios] = React.useState<SavedScenario[]>([]);

  React.useEffect(() => {
    setScenarios(getScenarios());
  }, []);

  if (scenarios.length === 0) return null;

  const handleDelete = (id: string) => {
    deleteScenario(id);
    setScenarios(getScenarios());
  };

  return (
    <div className="saved-scenarios">
      <h3>📁 Scenari salvati</h3>
      <div className="scenario-list">
        {scenarios.map(s => (
          <div key={s.id} className="scenario-item">
            <button
              type="button"
              className="scenario-load-btn"
              onClick={() => onLoad(s)}
            >
              <span className="scenario-name">{s.name}</span>
              <span className="scenario-meta">
                {s.users.length} persone → {s.destination}
              </span>
            </button>
            <button
              type="button"
              className="btn-remove"
              onClick={() => handleDelete(s.id)}
              aria-label="Elimina"
            >
              🗑️
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SavedScenarios;
